import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useTheme } from 'styled-components';
import { ArrowOutlineStyled, TriggerStyled, } from '../../../layout/navigation/styles';
import Collapse from '../../Collapse';
import Div from '../../div';
import { default as useSidebarBlocks, } from './sidebar-block';
import { SidebarPageSiderContainer } from './styles';
const SidebarPageSider = ({ sidebarBlocks, side, isCollapsed, handleCollapse, }) => {
    const theme = useTheme();
    const { fixedPanels, panels, defaultActiveKeys } = useSidebarBlocks({
        blocks: sidebarBlocks,
    });
    if (!(sidebarBlocks === null || sidebarBlocks === void 0 ? void 0 : sidebarBlocks.length))
        return _jsx(_Fragment, {});
    return (_jsxs(SidebarPageSiderContainer, { "$position": side, collapsible: true, collapsed: isCollapsed, onCollapse: handleCollapse, width: 300, collapsedWidth: 20, trigger: _jsx(TriggerStyled, { style: { top: theme.appearance.appHeaderHeight + 56 + 32 }, children: _jsx(ArrowOutlineStyled, { size: 24, style: {
                    transform: (isCollapsed && side === 'left') ||
                        (!isCollapsed && side === 'right')
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    transition: 'transform 500ms linear',
                } }) }), children: [_jsx(Div, { style: {
                    width: '100%',
                    opacity: isCollapsed ? 0 : 1,
                    pointerEvents: isCollapsed ? 'none' : 'auto',
                    transition: 'opacity 300ms ease-out',
                }, children: fixedPanels &&
                    fixedPanels.length > 0 &&
                    fixedPanels.map((panel) => (_jsx(Div, { style: { width: '100%' }, children: panel.content }, panel.id))) }), _jsx(Collapse, { ghost: true, style: { width: '100%', paddingBlock: 10 }, defaultActiveKey: defaultActiveKeys, noPadding: true, styles: {
                    panelContainer: {
                        padding: 0,
                        borderBottom: `1px solid ${theme.colors.grey_4}`,
                        opacity: isCollapsed ? 0 : 1,
                        transition: 'opacity 300ms ease-out',
                    },
                    panelContent: {
                        padding: '4px 20px 24px',
                    },
                    panelHeader: {
                        padding: '10px 24px',
                        gap: 8,
                    },
                }, expandIconPosition: "start", items: panels, ExpandIcon: ({ isActive }) => (_jsx(TabArrow, { down: isActive, size: 14, color: theme.colors.grey_3 })) })] }));
};
export default SidebarPageSider;
